import React, { forwardRef } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import BootstrapTable from '../bootstrap/Table.js';
import { jsx as _jsx } from "react/jsx-runtime";
const Table = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    className,
    borderless = false,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx(BootstrapTable, {
    className: clsx(className, {
      'table-borderless': borderless
    }),
    ref: ref,
    ...rest
  });
});
export default Table;